export default {"src":"/_next/static/media/chat.fd404113.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};